var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative",style:(_vm.triggerStyle),on:{"click":function($event){return _vm.toggle(_vm.id)}}},[_vm._t("default",null,{"triggerStyle":_vm.triggerStyle})],2)}
var staticRenderFns = []

export { render, staticRenderFns }